//@DEPRECATED, used only for backwards compatibility convertors etc

export interface IMMultilanguageString {
  lang: string,
  value: string,
}

export type IMMultilanguageStrings = IMMultilanguageString[]; // this makes me sad :(
